import { render, staticRenderFns } from "./BusinessHandle.vue?vue&type=template&id=7354090e&scoped=true&"
import script from "./BusinessHandle.vue?vue&type=script&lang=js&"
export * from "./BusinessHandle.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHandle.vue?vue&type=style&index=0&id=7354090e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354090e",
  null
  
)

export default component.exports